import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const weekendDays = useStore((state) => state.weekendDays);
  const setWeekendDays = useStore((state) => state.setWeekendDays);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.weekendDays.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={weekendDays}
          onChange={(value) => {
            setWeekendDays(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'weekend-days',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"Saturday and Sunday"}>
            <span>🍽️</span> {t('onboarding.weekendDays.options.saturdaySunday')}
          </Option>
          <Option value={"Friday, Saturday and Sunday"}>
            <span>🎉</span> {t('onboarding.weekendDays.options.fridaySaturdaySunday')}
          </Option>
          <Option value={"Friday and Saturday"}>
            <span>🌤️</span> {t('onboarding.weekendDays.options.fridaySaturday')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
